import React from "react";
import { Tr, Td, CheckboxCell, ActionBtn } from "./Table.style";
import { resolveColumnPresentation } from "./columnPresentation";

/**
 * TableRow – single data row with optional selection, actions, and custom cell render.
 */
export default function TableRow({
  row,
  rowIndex,
  columns,
  rowKey,
  isSelected,
  onSelect,
  actions,
  onRowClick,
  striped,
}) {
  const key = typeof rowKey === "function" ? rowKey(row) : (row[rowKey] ?? row.id ?? rowIndex);

  const handleRowClick = (e) => {
    if (
      onRowClick &&
      !e.target.closest('button, a, input, label, [role="switch"], .MuiSwitch-root')
    ) {
      onRowClick(row);
    }
  };

  return (
    <Tr
      $striped={striped}
      $index={rowIndex}
      $clickable={!!onRowClick}
      onClick={handleRowClick}
      data-row-key={key}
    >
      {onSelect != null && (
        <CheckboxCell>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              onSelect(key, e.target.checked);
            }}
            aria-label={`Select row ${key}`}
          />
        </CheckboxCell>
      )}
      {columns.map((col) => {
        const { cellAlign, wrap, width } = resolveColumnPresentation(col);
        return (
          <Td key={col.key} $align={cellAlign} $wrap={wrap} $width={width} $maxWidth={col.maxWidth}>
            {col.render ? col.render(row[col.key], row) : (row[col.key] ?? "–")}
          </Td>
        );
      })}
      {actions?.length > 0 && (
        <Td style={{ textAlign: "right" }}>
          {actions.map((action, i) => (
            <ActionBtn
              key={i}
              type="button"
              $variant={action.variant}
              onClick={(e) => {
                e.stopPropagation();
                action.onClick(row);
              }}
            >
              {action.label}
            </ActionBtn>
          ))}
        </Td>
      )}
    </Tr>
  );
}
